module.exports = __webpack_public_path__ + "img/hsp-pour.54577332.png";